var script_loaded = !1;
function loadJSscripts() {
  console.log("Loading scripts 18000ms");
  setTimeout(function () {
    if (!script_loaded) {
      script_loaded = !0;
      var t = document.getElementsByTagName("script");
      for (i = 0; i < t.length; i++)
        null !== t[i].getAttribute("data-src") &&
          (t[i].setAttribute("src", t[i].getAttribute("data-src")),
          delete t[i].dataset.src);
      var e = document.getElementsByTagName("link");
      for (i = 0; i < e.length; i++)
        null !== e[i].getAttribute("data-href") &&
          (e[i].setAttribute("href", e[i].getAttribute("data-href")),
          delete e[i].dataset.href);
      let scripts = document.getElementsByClassName("deferredScript");
      for (let i = 0; i < scripts.length; i++) {
        scripts[i].type = "text/javascript";
      }
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent("StartAsyncLoading"));
        document.dispatchEvent(new CustomEvent("StartKernelLoading"));
      }, 400);
    }
  }, 9000);
}
function loadJSscriptsNow() {
  if (!script_loaded) {
    console.log("now ...");
    script_loaded = !0;
    var t = document.getElementsByTagName("script");
    for (i = 0; i < t.length; i++)
      null !== t[i].getAttribute("data-src") &&
        (t[i].setAttribute("src", t[i].getAttribute("data-src")),
        delete t[i].dataset.src);
    var e = document.getElementsByTagName("link");
    for (i = 0; i < e.length; i++)
      null !== e[i].getAttribute("data-href") &&
        (e[i].setAttribute("href", e[i].getAttribute("data-href")),
        delete e[i].dataset.href);
    let scripts = document.getElementsByClassName("deferredScript");
    for (script in scripts) {
      script.type = "text/javascript";
    }
    setTimeout(function () {
      document.dispatchEvent(new CustomEvent("StartAsyncLoading"));
      document.dispatchEvent(new CustomEvent("StartKernelLoading"));
    }, 400);
  }
}
var activityEvents = [
  "mousedown",
  "mousemove",
  "keydown",
  "scroll",
  "touchstart",
  "click",
  "keypress",
  "touchmove",
];
activityEvents.forEach(function (eventName) {
  window.addEventListener(eventName, loadJSscriptsNow, { once: true, passive: true });
});
document.addEventListener("load", loadJSscripts, false);
document.addEventListener("onload", loadJSscripts, false);
if (window.addEventListener != undefined) {
  window.addEventListener("load", loadJSscripts, false);
} else if (window.attachEvent != undefined) {
  window.attachEvent("onload", loadJSscripts);
} else {
  window.onload = loadJSscripts;
}


var currentURL = window.location.href;
if(currentURL.indexOf("?") != -1){
  if(currentURL.split("?")[1] == 'page=1'){ 
    window.location.href = currentURL.split("?")[0];  // remove page=1 from current url
  }
}

if($(".paginate").length){
  $(".paginate .page").each(function(){
    var aURL = $(this).find("a").attr("href");
    if(aURL != undefined){
      if(aURL.split("?")[1] == 'page=1'){
        $(this).find("a").attr("href", aURL.split("?")[0]); // remove page=1 from current pagination links
      }
    }
  });
}

$('#minus-add').on('click',function(e) {
  var val = parseInt($(this).closest('.wrap-quantity').find('#quantity').val());
  val -= 1;
  if(val < 1){
    $(this).closest('.wrap-quantity').find('#quantity').val(1);    
  }else{
    $(this).closest('.wrap-quantity').find('#quantity').val(val);   
  }  
})

$('#add-plus').on('click',function(e) {
  var val = parseInt($(this).closest('.wrap-quantity').find('#quantity').val());
  val += 1;
  $(this).closest('.wrap-quantity').find('#quantity').val(val);   
})

$('.product-sticky-right-R a').on('click',function(e) {
   e.preventDefault();
   $('.purchase-details__buttons-full .add_to_cart').trigger('click'); 
   return false; 
})

$('.form-cover-right .buy-now_trigger').on('click',function(e) {
   e.preventDefault();
   var form = $(this).closest('form').serialize();
   $.ajax({
     method: "post",
     url: "/cart/add.js",
     data: form,
     dataType: "json",
     success:function(data) {
       var goToCheckout = function() { window.location.href = '/checkout'; };
       if (window.tfFreeGift && typeof window.tfFreeGift.sync === 'function') {
         window.tfFreeGift.sync().then(goToCheckout, goToCheckout);
       } else {
         goToCheckout();
       }
     },
     error: function(err) {
      console.log(err); 
     }
   })
   return false; 
})

/*
$(".stamped-reviews-wrap").click(function(){
  if($(".description ul.ui-tabs-nav").length){
    $(".description ul.ui-tabs-nav li").each(function(){
      if($(this).find("a").text() == "Reviews"){
        $(this).addClass("ui-tabs-active").addClass("ui-state-active");
        $(this).siblings().removeClass("ui-tabs-active").removeClass("ui-state-active");
        var divID = $(this).find("a").attr("href");
        $(".description > div.ui-tabs-panel").hide();
        $(".description "+divID).show();
        var tabObj = $(this);
        $('html, body').animate({
          scrollTop: tabObj.offset().top
        }, 500);
      }
    });
  }
});
*/